var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.mobile ? 'lightblue-section-mobile' : 'lightblue-section section-text',style:(_vm.mobile ? 'padding: 50px 20px; margin-top: 30px;' : 'padding: 70px 50px; margin-top: 60px;')},[_vm._v(" Send queries to: info[at]epiwatch.org ")])
}
var staticRenderFns = []

export { render, staticRenderFns }